import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { PlaceholderNote } from "../components/ComingSoon";
import { ANNOUNCEMENTS } from "../content/site";

export default function News() {
  return (
    <>
      <PageHero eyebrow="News & Updates" title="What’s happening" testId="news-hero">
        <p>
          Walk updates, new resources, community events, and foundation news will be
          shared here. Personal stories are published only with permission.
        </p>
      </PageHero>

      <section aria-labelledby="announcements-heading" className="px-4 pb-20 sm:px-8 lg:px-16">
        <div className="mx-auto max-w-3xl">
          <h2 id="announcements-heading" className="sr-only">Announcements</h2>
          <div className="space-y-6">
            {ANNOUNCEMENTS.filter((a) => a.sample || a.published).map((a, i) => (
              <Reveal key={i}>
                <article
                  className={`rounded-2xl border p-6 sm:p-8 ${
                    a.sample
                      ? "border-dashed border-gold/50 bg-gold-soft/30"
                      : "border-sage/10 bg-white"
                  }`}
                  data-testid={`news-announcement-${i + 1}`}
                >
                  {a.sample && (
                    <span className="mb-3 inline-block rounded-full bg-gold-soft px-3 py-1 text-xs font-semibold tracking-wide text-gold-dark">
                      Sample layout — not a real announcement
                    </span>
                  )}
                  <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
                    {a.date}
                  </p>
                  <h3 className="mt-2 font-serif text-xl font-medium text-ink sm:text-2xl">
                    {a.title}
                  </h3>
                  <p className="mt-3 text-base leading-relaxed text-body">{a.body}</p>
                </article>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-8">
            {ANNOUNCEMENTS.filter((a) => a.sample || a.published).length === 0 && (
              <PlaceholderNote testId="news-placeholder-note">
                <strong className="font-semibold text-ink">Nothing to announce yet.</strong>{" "}
                The first real update — likely the confirmed Walking for Hope date — will
                appear here. This page is edited from one simple list in the site’s content
                file.
              </PlaceholderNote>
            )}
          </Reveal>
        </div>
      </section>
    </>
  );
}
